import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setRectangleMode } from '../../actions/toolActions';
import ToolButton from '../ToolButton'
import MyIcon from '../Iconfont'
import {Tooltip} from 'antd'
import intl from 'react-intl-universal';

class RectangleBtn extends Component {
  render() {
    return (
      <Tooltip placement="top" title={intl.get('RECTANGLE_BUTTON')}>
        <ToolButton 
          icon={<MyIcon type="icon-toolrect"/>}
          onClick={() => this.props.setRectangleMode(!this.props.rectangleMode)}
          status={this.props.rectangleMode ?"active":"normal"}
        />
      </Tooltip>
    );
  }
}

const mapStateToProps = (state) => ({
  rectangleMode: state.toolStatus.rectangleMode
});

export default connect(mapStateToProps, { setRectangleMode })(RectangleBtn);
